import { CompanyEnrichType } from "@/enum/company-enrich-type.enum";

import { CompanyEnrich, CreateCompanyEnrich } from "../schema/companyEnrich";

const emptyCompanyFilterSearch = () => ({
	industries: [],
	employees: [],
	revenue: [],
	keywords: [],
	technologies: [],
});

/** The values a new Lead Database / Lookalike source starts from, before any prefill. */
export const buildInitialFormValues = (listId: number): Partial<CreateCompanyEnrich> => ({
	name: "",
	type: CompanyEnrichType.SEARCH,
	newInRole: null,
	query: null,
	positionQuery: [],
	countries: [],
	domains: [],
	seniority: [],
	department: [],
	education: null,
	excludePositionQuery: [],
	excludeCountries: [],
	excludeDomains: [],
	excludeSeniority: [],
	excludeDepartment: [],
	atCurrentCompanyAfter: null,
	atCurrentCompanyBefore: null,
	atCurrentPositionAfter: null,
	atCurrentPositionBefore: null,
	companyCountries: [],
	companyStates: [],
	companyCities: [],
	companyFilterSearch: emptyCompanyFilterSearch(),
	companyFilterSimilar: {
		similarDomains: [],
	},
	listId,
});

/** A saved source as the form edits it (without its id — the caller adds it when editing). */
export const formValuesFromSource = (
	companyEnrich: CompanyEnrich,
	listId: number
): Partial<CreateCompanyEnrich> => ({
	name: companyEnrich.name,
	type: companyEnrich.type ?? CompanyEnrichType.SEARCH,
	newInRole: companyEnrich.newInRole ?? null,
	query: companyEnrich.query,
	positionQuery: companyEnrich.positionQuery || [],
	countries: companyEnrich.countries || [],
	domains: companyEnrich.domains || [],
	seniority: companyEnrich.seniority || [],
	department: companyEnrich.department || [],
	education: companyEnrich.education ?? null,
	excludePositionQuery: companyEnrich.excludePositionQuery || [],
	excludeCountries: companyEnrich.excludeCountries || [],
	excludeDomains: companyEnrich.excludeDomains || [],
	excludeSeniority: companyEnrich.excludeSeniority || [],
	excludeDepartment: companyEnrich.excludeDepartment || [],
	atCurrentCompanyAfter: companyEnrich.atCurrentCompanyAfter,
	atCurrentCompanyBefore: companyEnrich.atCurrentCompanyBefore,
	atCurrentPositionAfter: companyEnrich.atCurrentPositionAfter,
	atCurrentPositionBefore: companyEnrich.atCurrentPositionBefore,
	companyCountries: companyEnrich.companyCountries || [],
	companyStates: companyEnrich.companyStates || [],
	companyCities: companyEnrich.companyCities || [],
	companyFilterSearch: companyEnrich.companyFilterSearch || emptyCompanyFilterSearch(),
	companyFilterSimilar: companyEnrich.companyFilterSimilar || {
		similarDomains: [],
	},
	excludeCompanies: companyEnrich.excludeCompanies ?? undefined,
	listId,
});
